import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import { Logo } from "@/components/common/Logo";
import { MobileNav } from "@/components/layout/MobileNav";
import { NAV_LINKS } from "@/config/site";
import { cn } from "@/lib/utils";

export const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <>
      <header
        data-testid="site-header"
        className="sticky top-0 z-40 border-b border-border-dark bg-brand-black/80 backdrop-blur-xl"
      >
        <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-6 lg:px-12">
          <Logo />

          <nav aria-label="Primary" className="hidden items-center gap-8 lg:flex">
            {NAV_LINKS.map((link) => {
              const active = pathname === link.path;
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`nav-${link.label.toLowerCase()}`}
                  className={cn(
                    "relative font-subheading text-sm font-semibold uppercase tracking-wide transition-colors",
                    link.live
                      ? "flex items-center gap-1.5 text-live-red hover:text-live-red/80"
                      : active
                        ? "text-white"
                        : "text-white/50 hover:text-white"
                  )}
                >
                  {link.live && <span className="h-1.5 w-1.5 rounded-full bg-live-red animate-pulse" aria-hidden="true" />}
                  {link.label}
                  {active && !link.live && (
                    <span className="absolute -bottom-2 left-0 h-0.5 w-full bg-brand-purple" aria-hidden="true" />
                  )}
                </Link>
              );
            })}
          </nav>

          <div className="flex items-center gap-4">
            <Link
              to="/live"
              data-testid="nav-watch-live-btn"
              className="hidden bg-brand-purple px-5 py-2.5 font-subheading text-sm font-semibold uppercase tracking-wide text-white transition-colors hover:bg-brand-purple-hover md:inline-flex"
            >
              Watch Live
            </Link>
            <button
              type="button"
              data-testid="mobile-menu-toggle"
              aria-label="Open menu"
              onClick={() => setMobileOpen(true)}
              className="inline-flex items-center justify-center p-2 text-white lg:hidden"
            >
              <Menu className="h-6 w-6" />
            </button>
          </div>
        </div>
      </header>
      <MobileNav open={mobileOpen} onClose={() => setMobileOpen(false)} />
    </>
  );
};
